import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { ProfileService } from './services/profile.service';
import { HecResponse } from '../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { LoaderService } from '../../../shared/sharedServices/loader.service';
import { GoogleAnalyticsService } from '../../../shared/sharedServices/google-analytics.service';
import { decrypt, encrypt } from '../../../utilities/utilityFunctions';

@Component({
  selector: 'kt-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public loader: boolean = false;
  public dropdownList:any;
  public personalDetailsData:any;
  public isLocked:boolean;
  public nationalityData:any;
  public profileAvatarImg: string = '/assets/media/users/default.jpg';
  public profileData:any;
  public pageState:number=1;
  public wizard:any;
  public userContactPhone;
  public userContactEmail;
	submitted = false;
	@ViewChild('wizard', {static: true}) el: ElementRef;

  constructor(private sharedService:SharedService, private profileService:ProfileService,
    private gaService:GoogleAnalyticsService,
    private cdr:ChangeDetectorRef, private loaderService:LoaderService) {
	}

	async ngOnInit() {
    this.gaService.setPage('/profile','Common Profile');
    if(localStorage.getItem('Avatar') != undefined && localStorage.getItem('Avatar') != ''){
    this.profileAvatarImg = decrypt(localStorage.getItem('Avatar'))
    }else{
      this.profileAvatarImg = '/assets/media/users/default.jpg';
    }
    await this.getProfileDropdownData();
    await this.getUserPersonalDetails();
    await this.getUserContactDetails();

  }
  public getUserContactDetails(){
    this.profileService.getContactDetails().subscribe(
      (res:HecResponse)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data.length > 0){
          for(let i=0; i < res.data.length;i++){
            if(res.data[i].contactTypeCode == 10191){
              this.userContactEmail = res.data[i].contactValue
            }else if(res.data[i].contactTypeCode == 10195){
              this.userContactPhone = res.data[i].countryDialingCode + res.data[i].contactValue
            }
          }
          this.cdr.detectChanges();
        }
      }
    )
  }

	public getUserPersonalDetails() {
    this.loader = true;
    this.loaderService.setValue(this.loader);
    this.cdr.detectChanges();
    return new Promise((resolve, reject) => {
    this.sharedService.getPersonalDetails().subscribe(
      (res: HecResponse) => {
        this.loader = false;
        this.loaderService.setValue(this.loader)
        this.cdr.detectChanges();
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.profileData = res.data;
          this.isLocked = res.data.islocked;
          this.personalDetailsData = res.data.personalDetail;
          localStorage.setItem('dob',encrypt(res.data.personalDetail.dateOfBirth))
          this.nationalityData = res.data.nationalityDtos;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
          resolve(this.personalDetailsData);
        }
        (err) => {
        }
      }
    )
  })
  .catch(function (error) {
  })
  }

  public checkAction(){
    this.pageState = this.wizard.currentStep;
        this.cdr.detectChanges();
  }

  public getProfileDropdownData() {
    return new Promise((resolve, reject) => {
    this.profileService.getProfileFormData().subscribe(
      (res:HecResponse)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.dropdownList = res.data;
          resolve(this.dropdownList);
          this.cdr.detectChanges();
        }
      }
    )
  })
  .catch(function (error) {
  })
  }

	ngAfterViewInit(): void {
		this.wizard = new KTWizard(this.el.nativeElement, {
			startStep: 1
		});
		this.wizard .on('beforeNext', (wizardObj) => {
		});

		this.wizard .on('change', () => {
			setTimeout(() => {
				KTUtil.scrollTop();
			}, 500);
		});
	}

  goNext()
    {
        this.wizard.goNext();
        this.pageState = this.wizard.currentStep;
        this.cdr.detectChanges();
    }

    tabClick(tabNumber){
      this.pageState = tabNumber;
      this.wizard.goTo(tabNumber)
      this.cdr.detectChanges();
    }
	onSubmit(e) {
   	this.submitted = true;
	}
}
